(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olas-product-carryon"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('olas-pdp-{{ section.id }}');
  if (!section) return;
  var variantInput = section.querySelector('#olas-variant-id-{{ section.id }}');
  var priceEl = section.querySelector('#olas-price-{{ section.id }}');
  var colorLabel = section.querySelector('#olas-color-label-{{ section.id }}');
  var atcBtn = section.querySelector('#olas-atc-{{ section.id }}');
  var qtyInput = section.querySelector('#olas-qty-{{ section.id }}');
  var qtyHidden = section.querySelector('#olas-qty-hidden-{{ section.id }}');
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  section.querySelectorAll('[name="olas-color-{{ section.id }}"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var variantId = this.dataset.variantId;
      var price = parseInt(this.dataset.price, 10);
      var available = this.dataset.available === 'true';
      var color = this.dataset.color;
      if (variantInput) variantInput.value = variantId;
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (colorLabel) colorLabel.textContent = color;
      section.querySelectorAll('.olas-swatch').forEach(function(s) { s.classList.remove('is-selected'); });
      this.closest('.olas-swatch').classList.add('is-selected');
      if (atcBtn) { atcBtn.disabled = !available; atcBtn.textContent = available ? 'Add to bag' : 'Out of stock'; }
      history.replaceState(null, '', '?variant=' + variantId);
    });
  });
  if (qtyInput) {
    section.querySelectorAll('.olas-qty__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value, 10) || 1;
        var next = this.dataset.action === 'plus' ? current + 1 : Math.max(1, current - 1);
        qtyInput.value = next;
        if (qtyHidden) qtyHidden.value = next;
      });
    });
    qtyInput.addEventListener('input', function() {
      var v = parseInt(this.value, 10);
      if (!isNaN(v) && v > 0 && qtyHidden) qtyHidden.value = v;
    });
  }
  var form = section.querySelector('#olas-form-{{ section.id }}');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (atcBtn && atcBtn.disabled) return;
      var formData = { id: variantInput ? variantInput.value : '', quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1 };
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(formData.id), quantity: formData.quantity }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Added'; }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() { if (atcBtn) atcBtn.textContent = 'Add to bag'; }, 1800);
      })
      .catch(function() { if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to bag'; } });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
